module.exports = __webpack_public_path__ + "img/credit-card.2ffaced7.jpg";